import { RootState } from 'store'

export const getBanner = (state: RootState) => state.banner
export const getAffiliate = (state: RootState) => state.affiliate
export const getUser = (state: RootState) => state.auth
export const getUserDetail = (state: RootState) => state.userDetail
export const getMyAffiliates = (state: RootState) => state.myAffiliates
